import { type TreeDataItem } from 'components/FilesTree/types'
import { type AlmanacFile } from 'types'

export enum Structure {
  TRADITIONAL = 'Traditional',
  PROBLEM_SOLUTION = 'Problem-Solution',
  HOW_TO = 'How-to',
  STORYTELLING = 'Storytelling',
  INTERVIEW = 'Interview',
  VIDEO_PODCAST_SCRIPT = 'Video/Podcast Script',
  DISCUSSION = 'Discussion',
}

export enum RevisionType {
  CHANGE_TONE = 'change_tone',
  CHANGE_LENGTH = 'change_length',
  CUSTOM_PROMPT = 'custom_prompt',
  TRANSLATE = 'translate',
  CUSTOM_DESIGN = 'custom_design',
}

export enum RevisionLevel {
  LIGHT = 'Light',
  MODERATE = 'Moderate',
  HEAVY = 'Heavy',
}

export enum RevisionAction {
  MAKE_LONGER = 'make_longer',
  MAKE_SHORTER = 'make_shorter',
  SUMMARIZE = 'summarize',
  SIMPLIFY = 'simplify',
}

export enum RevisionLayer {
  CURRENT_LAYER = 'Current Layer',
  NEW_LAYER = 'New Layer',
}

export interface BlazeCommandLineProps {
  createInFolder?: AlmanacFile | TreeDataItem | null
}
